module.exports = __webpack_public_path__ + "static/media/eyeIcon.264f2f18.svg";